import { render } from "./EmployeeLeaveHistory.vue?vue&type=template&id=718fe0f6&scoped=true"
import script from "./EmployeeLeaveHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveHistory.vue?vue&type=script&lang=js"

import "./EmployeeLeaveHistory.vue?vue&type=style&index=0&id=718fe0f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718fe0f6"]])

export default __exports__